import { render, staticRenderFns } from "./historyDialog.vue?vue&type=template&id=ea2d48b6&"
import script from "./historyDialog.vue?vue&type=script&lang=js&"
export * from "./historyDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports